import React from 'react';

const CompanyAmountTypeTitle = ({ record }) => {
	return <span>Company AmounType {record ? `"${record.name}"` : ''}</span>;
};

export default CompanyAmountTypeTitle;
